// extracted by mini-css-extract-plugin
export var cardLayout = "_5j-1";
export var paginationContainer = "_5j-0";